import { LastDailyBar } from "../models/charts";

// Shared "last bar seen per symbol" cache, keyed by symbolInfo.full_name.
// Written by the datafeed on every firstDataRequest getBars; read by the
// streaming provider to reseed a bar handler after a post-reconnect /history
// refetch (see the pendingReload path), so ticks resume on the freshly
// backfilled history instead of the stale pre-gap bar. Kept in its own module
// so both the datafeed and the streaming provider can share it without a
// circular import between them.
export const LastBarsCache = new Map<string, LastDailyBar>();
